import { postWithTrace } from "../utils/http";
import url from "../utils/url";
import helper from "../utils/helpers";
import { API_CANAL, API_CANAL_AMI, API_NUEVO_CANAL, API_ONE_STEP } from "../utils/consts";
import Cookies from 'js-cookie';

import axios from "axios";
import { markingAudienceId } from "./MarkingsServices";

export const getConsultSoat = async (data) => {
    const path = url.PATH_CONSULT_SOAT;
    const name = API_CANAL;
    const request = helper.converterRequest(data, API_NUEVO_CANAL);

    return await postWithTrace({
        path,
        data: request,
        name,
    });

};

export const getConsultSoatPrint = async (data) => {
    const path = url.PATH_PRINT_CONSULT_SOAT;
    const name = API_CANAL;
    const request = helper.converterRequest(data, API_NUEVO_CANAL);

    return await postWithTrace({
        path,
        data: request,
        name,
    });

};

export const getSoatOneStep = async (data) => {
    const path = url.PATH_SOAT_ONE_STEP;
    const name = API_ONE_STEP;
    const request = helper.converterRequest(data, API_ONE_STEP);
    return await postWithTrace({
        path,
        data: request,
        name,
    });

};

// temporal servicios sin seguridad

export const getConsultSoatPrint_ = async (data) => {
    const service = 'https://www.rimac.com.pe/ConsultaSOAT/services/imprimirConstanciaElectronica.do';

    return axios.post(service, {
        idptipdocumento: "1",
        numdocumento: data.numeroDocumento,
        placavehiculo: data.placa,
        telefono: "",
        correo: data.correo,
        indenviocorreo: data.indEnvioCorreo,
        idetransaccion: ""
    })
        .then(function (response) {
            return {
                payload: {
                    rutaConstancia: response?.data?.rutaconselectronica,
                }
            }
        })
        .catch(function (error) {
            return error.response.data
        });

}
export const getConsultSoat_ = async (data) => {

    const service = 'https://www.rimac.com.pe/ConsultaSOAT/services/obtConstanciaElectronica.do';

    return axios.post(service, {
        idptipdocumento: "1",
        numdocumento: data.numeroDocumento,
        placavehiculo: data.placa
    })
        .then(function (response) {
            let datos = response?.data?.datosConstElectronica[0];
            return {
                payload: {
                    fechaIinicioVigencia: datos?.fecinivig,
                    fechaFinVigencia: datos?.fecfinvig,
                    fechaEmimsion: datos?.fecemision,
                    url: datos?.urlconstelectronica,
                }
            }
        })
        .catch(function (error) {
            return error.response.data
        });

}

// get audience_id

export const createDigitalId = async (payload) => {
    try{
    const path = url.PATH_DIGITAL_ID;
    const name = API_CANAL_AMI;
    const request = helper.converterRequest(payload, API_ONE_STEP);

    const response =  await postWithTrace({
        path,
        data: request,
        name,
    });
      if (
      response?.payload.id !== null 
    ) {
      Cookies.set('audience.authstate', true , {
        expires: 1,
        path: '/',
        domain:'.rimac.com',
      })
      Cookies.set('audience.digital_id', response.payload.id, {
        expires: 1,
        path: '/',
        domain:'.rimac.com',
      })
      markingAudienceId(response.payload.id)
    }
    return null;
  } catch (err) {
    console.log('err', err);
  }
};